/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    alignItems: 'stretch',
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: 'flex-start',
    width: null
  }
}
export default theme
